import * as React from 'react';

import classNames from 'classnames';

import type { InjectedRouter } from 'js/lib/connectToRouter';

import type { statusType } from 'bundles/teams-v2/components/TeamsCheckoutProgressIcon';
import TeamsCheckoutProgressIcon from 'bundles/teams-v2/components/TeamsCheckoutProgressIcon';
import { isCheckingOutForExistingOrg } from 'bundles/teams-v2/components/utils';
import { ACTIVE, DISABLED, DONE } from 'bundles/teams-v2/constants/progressStatus';

import _t from 'i18n!nls/teams-v2';

import 'css!./__styles__/TeamsCheckoutProgressBar';

type Props = {
  router: InjectedRouter;
  path: string;
};

const TeamsCheckoutProgressBar = ({ path, router }: Props) => {
  let planStatus: statusType | undefined;
  let accountStatus: statusType | undefined;
  let billingStatus: statusType | undefined;
  switch (path) {
    case 'plan':
      planStatus = ACTIVE;
      accountStatus = DISABLED;
      billingStatus = DISABLED;
      break;
    case 'account':
      planStatus = DONE;
      accountStatus = ACTIVE;
      billingStatus = DISABLED;
      break;
    case 'verify':
      planStatus = DONE;
      accountStatus = ACTIVE;
      billingStatus = DISABLED;
      break;
    case 'billing':
      planStatus = DONE;
      accountStatus = DONE;
      billingStatus = ACTIVE;
      break;
    default:
      break;
  }
  if (!planStatus || !accountStatus || !billingStatus) {
    return null;
  }

  const shouldShowSecondStep = !isCheckingOutForExistingOrg(router);
  // If a contract is being purchased for an existing org, we skip the second step - account setup
  return (
    <div
      className="rc-TeamsCheckoutProgressBar horizontal-box align-items-absolute-center"
      data-testid="teams-checkout-progress-bar"
    >
      <TeamsCheckoutProgressIcon label={_t('Plan Details')} status={planStatus} />
      <div className={classNames('c-TeamsProgressSeparator', { greyedOut: billingStatus !== ACTIVE })} />
      {shouldShowSecondStep && <TeamsCheckoutProgressIcon label={_t('Account Details')} status={accountStatus} />}
      {shouldShowSecondStep && (
        <div className={classNames('c-TeamsProgressSeparator', { greyedOut: billingStatus !== ACTIVE })} />
      )}
      <TeamsCheckoutProgressIcon label={_t('Billing Information')} status={billingStatus} />
    </div>
  );
};

export default TeamsCheckoutProgressBar;
